var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfilePicture(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "person_add-24px") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Prozess",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5.-Dokumente",
    transform: "translate(-629.000000, -290.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Data",
    transform: "translate(520.000000, 238.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Profil-Input",
    transform: "translate(0.000000, 38.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "person_add-24px",
    transform: "translate(109.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 20 0 20 20 0 20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9166667,10.4166667 C14.7583333,10.4166667 16.25,8.925 16.25,7.08333333 C16.25,5.24166667 14.7583333,3.75 12.9166667,3.75 C11.075,3.75 9.58333333,5.24166667 9.58333333,7.08333333 C9.58333333,8.925 11.075,10.4166667 12.9166667,10.4166667 Z M5.41666667,8.75 L5.41666667,6.25 L3.75,6.25 L3.75,8.75 L1.25,8.75 L1.25,10.4166667 L3.75,10.4166667 L3.75,12.9166667 L5.41666667,12.9166667 L5.41666667,10.4166667 L7.91666667,10.4166667 L7.91666667,8.75 L5.41666667,8.75 Z M12.9166667,12.0833333 C10.6916667,12.0833333 6.25,13.2 6.25,15.4166667 L6.25,17.0833333 L19.5833333,17.0833333 L19.5833333,15.4166667 C19.5833333,13.2 15.1416667,12.0833333 12.9166667,12.0833333 Z",
    id: "Shape",
    fill: "#999999",
    fillRule: "nonzero"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilePicture);
export default __webpack_public_path__ + "static/media/Profile_picture.f3db6491ff340587e4db55dca1cccbc1.svg";
export { ForwardRef as ReactComponent };